import { useEffect } from "react";
import { useTranslation } from "react-i18next";

import appStore from "../../assets/app-store-en.svg";
import card from "../../assets/card.svg";
import qr from "../../assets/download-app-qr.svg";
import googlePlay from "../../assets/google-play-badge-en.svg";
import logoCobee from "../../assets/logo-cobee.svg";
import { useAuth } from "../../auth";
import { Footer } from "../../components/footer";
import { useMetrics } from "../../metrics";
import classes from "./RegisterCompleted.module.css";

const RegisterCompleted = () => {
  const { pageView, trackAction } = useMetrics();
  const { t } = useTranslation();
  const { loginWithRedirect } = useAuth();

  useEffect(() => {
    pageView("RegisterCompleted");
  }, []);

  const handleOnClickLoginButton = () => {
    trackAction.click({
      screenName: "RegisterCompleted",
      componentName: "button login",
    });
    loginWithRedirect();
  };

  return (
    <div className={classes.container}>
      <header className="grid grid-cols-12 mt-4 h-16 items-center w-4/5">
        <div className="flex justify-center col-start-3 col-span-8">
          <img className={classes.logo} src={logoCobee} alt="Logo de Cobee" />
        </div>
      </header>
      <h1 className={classes.title}>{t("downloadApp.title")}</h1>
      <p className={classes.description}>{t("downloadApp.description")}</p>
      <p className={classes.description}>
        {t("downloadApp.description2")}&nbsp;
        <button
          className={`text-secondary-main underline`}
          onClick={handleOnClickLoginButton}
        >
          {t("downloadApp.loginProcess.link")}
        </button>
      </p>
      <img
        className={classes.card}
        src={card}
        alt={t("downloadApp.image.altDescription")}
      ></img>
      <img
        className={classes.qr}
        src={qr}
        alt={t("downloadApp.QRimage.altDescription")}
      ></img>
      <div className={classes.storeButtonsContainer}>
        <button className={classes.storeButton}>
          <img
            className={classes.storeImage}
            src={googlePlay}
            alt="Google Play Store"
          ></img>
        </button>
        <button className={classes.storeButton}>
          <img
            className={classes.storeImage}
            src={appStore}
            alt="App Store"
          ></img>
        </button>
      </div>
      <form
        className={classes.buttonContainer}
        action="https://onelink.to/duxjhf"
        aria-label="send"
      >
        <button className={classes.button}>
          {t("downloadApp.button.downloadApp")}
        </button>
      </form>
      <Footer />
    </div>
  );
};

export { RegisterCompleted };
